// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { articlesModel } from '@/firebase/firebase-config'

export const GetArticle = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        article: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getArticleHandler: async function() {

            try {

                // Get the user doc
                articlesModel.where('attributes.slug', '==', this.$route.params.slug).get()
                .then(snapshot => {

                    if (snapshot.empty) {

                        /*
                        **  Send to 404 not found
                        */

                        this.$router.push({ name: 'NotFound' });

                    }

                    /*
                    **  Loop through the results and set the document
                    */

                    snapshot.forEach(doc => {

                        /*
                        **  Set the article prop
                        **  @prop_location: @here
                        */

                        this.article = doc.data();

                    });
                    

                })
                .catch(error => {

                    /*
                    **  Send to 404 not found
                    **  @service: Router
                    */

                    this.$router.push({ name: 'NotFound' });

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportNoAuthBugsnagError({
                        title: 'Get Article Document from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Articles',
                        uid: '7oEnBCZM7vI316CbvCyl',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to 404 not found
                **  @service: Router
                */

                this.$router.push({ name: 'NotFound' });

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportNoAuthBugsnagError({
                    title: 'Unable to Query Firestore When Getting an Article Document.',
                    errorType: 'Firestore Database',
                    section: 'Events/Articles',
                    uid: 'eledYrLkfhOcLFxiaOEt',
                    error: e
                });

            }

        }

    }

}